import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BasicTextArea, BaasicButton } from 'core/components';
function NikoTemplateMissingProductNoteModalTemplate({ nikoTemplateMissingProductNoteModalStore, t }) {
    const {
        form,
        resolveMissingProductNote,
        disabled,
        isEditDisabled
    } = nikoTemplateMissingProductNoteModalStore;

    const onKeyDown = (e) => {
        if (e.keyCode == 13) {
            e.preventDefault();
            form.onSubmit(e);
        }
    }

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Missing Product Note</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicTextArea field={form.$('missingProductNote')} onKeyDown={onKeyDown} isFocus={true} disabled={disabled || isEditDisabled} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.RESOLVE')}
                    rotate
                    icon={
                        disabled
                            ? "u-icon u-icon--sml u-icon--sync u-rotate--login u-mar--right--tny"
                            : "u-icon u-icon--xmed u-icon--check"
                    }
                    onClick={() => resolveMissingProductNote()}
                    disabled={form.submitting || form.validating || disabled}
                />
                <BaasicFormControls
                    form={form}
                    className='btn btn--med btn--primary'
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating || disabled || isEditDisabled}
                    label={t('EDIT_FORM_LAYOUT.SAVE')}
                />
            </div>
        </section>
    )
}

NikoTemplateMissingProductNoteModalTemplate.propTypes = {
    nikoTemplateMissingProductNoteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(NikoTemplateMissingProductNoteModalTemplate);
